module.exports = __webpack_public_path__ + "static/media/standing-light-green.70a1f16a.svg";